import {API} from 'aws-amplify';
import {awsApiName} from '../../shared/amplify/amplify-utils';
import {TitleSectionTemplate} from '../../entity/model/title-section-template';
import {RequestBody} from '../../entity/core/request-body';

export default class TitleSectionTemplateAgent {

  getTitleSectionTemplates = async (organizationId: string): Promise<TitleSectionTemplate[]> => {
    return await API.get(awsApiName, `/organizations/${organizationId}/title-section-templates`, {});
  }

  createTitleSectionTemplate = async (organizationId: string, requestBody: RequestBody): Promise<TitleSectionTemplate> => {
    return API.post(awsApiName, `/organizations/${organizationId}/title-section-templates`, requestBody);
  }

  updateTitleSectionTemplate = async (organizationId: string, titleSectionTemplateId: string, requestBody: RequestBody): Promise<TitleSectionTemplate> => {
    return API.patch(awsApiName, `/organizations/${organizationId}/title-section-templates/${titleSectionTemplateId}`,requestBody);
  }

  deleteTitleSectionTemplate = async (organizationId: string, titleSectionTemplateId: string): Promise<void> => {
    return API.del(awsApiName, `/organizations/${organizationId}/title-section-templates/${titleSectionTemplateId}`, {});
  }
}